<template>
    <CListGroup>
        <slot />
    </CListGroup>
</template>

<script setup>
import { CListGroup } from '@coreui/vue-pro'
</script>

<style scoped>

</style>
